module.exports = __webpack_public_path__ + "static/media/mills_schmidt_gerbauer_weiss.0708fa5a.gif";